var $92192aa23ec84b2d$exports = {};
$92192aa23ec84b2d$exports = {
    "invalidSelection": (args, formatter)=>`Valgte ${formatter.plural(args.selectedCount, {
            one: `dato`,
            other: `datoer`
        })} ikke ledige.`
};


export {$92192aa23ec84b2d$exports as default};
//# sourceMappingURL=da-DK.module.js.map
